export const getDigitalCertificate = (state) => state.digital_certificate
